import { flow, types } from 'mobx-state-tree'
import { getConsents } from '../../network/getConsents'
import { RootStore } from '../store'

const Consent = types.model('Consent', {
  status: types.optional(types.string, ''),
  text1: types.optional(types.string, ''),
  fromDate: types.optional(types.string, ''),
  toDate: types.optional(types.string, ''),
  activityType: types.optional(types.string, ''),
  consentTextCode: types.optional(types.string, ''),
})

const Consents = types
  .model('Consents', {
    consentData: types.maybeNull(types.array(Consent)),
    appType: types.optional(types.string, '3'),
  })
  .actions((self) => ({
    getConsentsApi: flow(function* getConsentsApi() {
      const res = yield getConsents(RootStore.agent.session).catch((err: any) => {
        RootStore.message.handleError(err)
        throw err
      })
      self.consentData = res
      return res
    }),
    updateAppType(value: string) {
      self.appType = value
    },
  }))
  .views((self) => ({
    getConsent: (activityType: keyof typeof CONSENTS) => {
      return self?.consentData?.filter((item) => item.activityType === CONSENTS[activityType])?.[0]?.text1 || ''
    },
    getConsentDetails: (activityType: keyof typeof CONSENTS) => {
      return (self?.consentData?.filter((item) => item.activityType === CONSENTS[activityType])?.[0] || {}) as any
    },
  }))

export const CONSENTS = {
  AGENT_FINGER_PRINT: 'AE_PSATXNS',
  CUSTOMER_CW: 'AE_PSCTXNS_CW',
  CUSTOMER_CD: 'AE_PSCTXNS_CD',
  CUSTOMER_BI: 'AE_PSCTXNS_BI',
  CUSTOMER_FT: 'AE_PSCTXNS_FT',
  CUSTOMER_MS: 'AE_PSCTXNS_MS',
  LINK_AADHAAR: 'AE_PSATXNS',
  DMR_TRANSFER_FUND: 'AE_PSDMRP',
  DMR_NAME_CONFIRMATION: 'AE_PSDMRV',
  DMR_FINGER_PRINT: 'DMR_AUTH',
  DMR_ENTER_AADHAAR: 'DMR_EKYC',
}

const ConsentsData = Consents.create({})

export { Consents, ConsentsData }
